<script setup>
import {computed, inject, ref, toRef} from 'vue';
import {Field, useField} from 'vee-validate';
import {boolean} from 'yup';
import {string} from 'yup';
import {defaultFieldProps} from '../helpers/defaultProps';
import {useDccsField} from '../composables/useDccsField';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const props = defineProps({
    ...defaultFieldProps,
});

const emit = defineEmits(['update:modelValue']);

const busy = inject('busy');

const {normalizedRequired} = useDccsField(props);
const validationRules = computed(() => {

    if (normalizedRequired.value === true) {
        let validator = boolean();

        validator = validator
            .required('')

        return validator;

    } else{
        let validator = string();
        return validator;

    }


});

const refName = toRef(props, 'name');
const {errorMessage, value, checked, handleChange,resetField} = useField(refName, validationRules, {
    type: 'checkbox',
    checkedValue: true,
    uncheckedValue: false,
    initialValue: false,
});

const labelRef = ref(null);

resetField({
    value: '',
});

</script>

<template>
    <Field
        v-slot="{ field, meta,errors }"
        v-model="value"
        :name="name"
        :rules="validationRules"
        :label="label"
        as="div"
        class="merkur-field"
    >
        <label ref="label" class="merkur-checkbox" @keydown.prevent.enter="labelRef.click()">

            <input
                v-bind="field"
                :name="name"
                type="checkbox"
                :required="normalizedRequired"
                :disabled="busy"
                :class="[{ 'has-error': normalizedRequired && (meta.touched || errors.length) }, { 'is-danger': normalizedRequired && (meta.validated && !meta.valid)  || normalizedRequired && (errors.length) }]"
                :checked="checked"
                @change="handleChange"
            />
            <span
                :class="['control-label',{ 'has-error': normalizedRequired && (meta.touched || errors.length) }, { 'is-danger': normalizedRequired && (meta.validated && !meta.valid)   || normalizedRequired && (errors.length) }]"
            >
                <slot/>
            </span>
        </label>
    </Field>
</template>
